export const createTitleCase = (value: string) => {
  const valueCase = value.toLocaleLowerCase().replace(/([A-Z])/g, ' $1');
  const titleCase = `${valueCase.charAt(0).toUpperCase()}${valueCase.slice(1)}`;
  return titleCase;
};

const createRangeTitle = (title: string) => {
  if (title.includes('Effective Price Range')) {
    return 'Price';
  }
  title = title.replace(' Range', '');
  return title;
};

export const createFilterTitle = (facet: string) => {
  if(facet === 'PromoCategory') return 'Featured Deals';
  const facetCase = facet.replace(/([A-Z])/g, ' $1');
  const facetTitle = `${facetCase.charAt(0).toUpperCase()}${facetCase.slice(1)}`;
  return createRangeTitle(facetTitle);
};
